(function(register){
    if (document.readyState !== 'loading') {
        register();
    } else {
        document.addEventListener('DOMContentLoaded', register, {
            once: true,
            passive: true,
        });
    }
})(function() {
    /**
     * @deprecated you should use htmx insteadof this custom element
     */
    if (customElements.get('base-fetch-container') === undefined) {
        const template = document.createElement('template');
        template.innerHTML = `
        <style>
        :host {
          display: block;
        }
        :host([overlay-loader]) [part="wrapper"] {
            display: grid;
            grid-template-areas: "def";
        }
        :host([overlay-loader]) [part="body"] {
            grid-area: def;
            transition: opacity .5s ease;
        }
        :host([overlay-loader][loading]) [part="body"] {
            opacity: 0;
        }
        :host(:not([overlay-loader])) [part="loader-container"],
        :host([overlay-loader]:not([loading])) [part="loader-container"] {
            display: none;
        }
        :host([overlay-loader]) [part="loader-container"] {
            grid-area: def;
            display: flex;
            width: 100%;
            height: 100%;
            align-items: center;
            justify-content: center;
        }
        /* no slot loader (default/fallback) */
        [part="loader"] {
            width: 100%;
            height: 100%;
            background-color: rgba(255, 255, 255, .75);
            display: flex;
            align-items: center;
            justify-content: center;
        }
        [part="loader-text"]::before {
            content: "Loading";        
        }
        </style>
        <div part="wrapper">
            <div part="body">
                <slot></slot>
            </div>
            <div part="loader-container">
                <slot name="overlay-loader"><div part="loader"><span part="loader-text"></span></div></slot>
            </div>
        </div>
        `;
        customElements.define('base-fetch-container', class extends HTMLElement {
            get target() {
                return this.getAttribute('target')
                    ? this.querySelector(this.getAttribute('target'))
                    : this;
            }
            get history() {
                return this.getAttribute('history');
            }
            constructor() {
                super();
                this.attachShadow({mode: "open"}).appendChild(template.content.cloneNode(true));
                this.items = [];
                new MutationObserver(() => {
                    this.updateItems();
                }).observe(this, {
                    childList: true,
                    subtree: true,
                });
            }
            connectedCallback() {
                this.updateItems();
            }
            updateItems() {
                this.items = this.items.filter(item => item.isConnected);
                const allChildElements = Array.from(this.querySelectorAll('[data-fetch]'));
                const validItems = allChildElements.filter(child => child.closest('base-fetch-container') === this);
                for (let item of validItems) {
                    this.addItem(item);
                }
            }
            addItem(item) {
                if (this.items.indexOf(item) === -1) {
                    this.items.push(item);
                    const handleResponse = async (text) => {
                        const target = this.getAttribute('target')
                            ? this.querySelector(this.getAttribute('target'))
                            : this;
                        if (this.getAttribute('extract')) {
                            const parsed = new DOMParser().parseFromString(text, 'text/html');
                            const extracted = parsed.querySelector(this.getAttribute('extract'));
                            target.innerHTML = '';
                            target.insertAdjacentElement('afterbegin', extracted);
                        } else {
                            target.innerHTML = text;
                        }
                        this.dispatchEvent(new CustomEvent('fetch.end', {
                            bubbles: true,
                            detail: {
                                item,
                                target,
                            }
                        }));
                        return true;
                    };
                    const updateHistory = (uri) => {
                        if (this.history === 'push') {
                            history.pushState({}, null, uri);
                        } else if (this.history === 'replace') {
                            history.replaceState({}, null, uri);
                        }
                    }
                    if (item instanceof HTMLAnchorElement) {
                        item.addEventListener('click', event => {
                            event.preventDefault();
                            const fetchEvent = new CustomEvent('fetch.start', {
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    item,
                                }
                            });
                            this.dispatchEvent(fetchEvent);
                            if (!fetchEvent.defaultPrevented) {
                                this.setAttribute('loading', item.dataset.fetch);
                                fetch(item.dataset.fetch)
                                    .then(response => response.text())
                                    .then(text => {
                                        if (this.history && item.href) {
                                            updateHistory(item.href);
                                        }
                                        return text;
                                    })
                                    .then(text => handleResponse(text))
                                    .then(() => {
                                        this.removeAttribute('loading');
                                    })
                                    .catch(error => {
                                        console.error(error);
                                        this.removeAttribute('loading');
                                    });
                            }
                        });
                    } else if (item instanceof HTMLFormElement) {
                        item.addEventListener('submit', async event => {
                            event.preventDefault();
                            let uri = item.dataset.fetch;
                            let options = {
                                method: item.method,
                            };
                            const formData = new FormData(item);
                            if (event.submitter && event.submitter.getAttribute("name") && !formData.has(event.submitter.getAttribute("name"))) {
                                formData.append(
                                    event.submitter.getAttribute("name").toString(),
                                    event.submitter.getAttribute("value").toString()
                                );
                            }
                            const isGetRequest = item.method.toUpperCase() === 'GET';
                            if (isGetRequest) {
                                uri += uri.indexOf('?') > -1 ? '&' : '?';
                                uri += new URLSearchParams(formData).toString();
                            } else {
                                if (item.enctype.toLowerCase() === 'multipart/form-data') {
                                    options.body = formData;
                                } else {
                                    options.body = new URLSearchParams(formData);
                                    options.headers = {};
                                    options.headers['Content-Type'] = 'application/x-www-form-urlencoded';
                                }
                            }
                            const fetchEvent = new CustomEvent('fetch.start', {
                                bubbles: true,
                                cancelable: true,
                                detail: {
                                    item,
                                    formData,
                                    uri,
                                    options,
                                }
                            });
                            this.dispatchEvent(fetchEvent);
                            if (!fetchEvent.defaultPrevented) {
                                this.setAttribute('loading', uri);
                                fetch(uri, options)
                                    .then(response => response.text())
                                    .then(text => {
                                        if (this.history && isGetRequest) {
                                            let actionUri = item.action;
                                            actionUri += actionUri.indexOf('?') > -1 ? '&' : '?';
                                            actionUri += new URLSearchParams(formData).toString();
                                            updateHistory(actionUri);
                                        }
                                        return text;
                                    })
                                    .then(text => handleResponse(text))
                                    .then(() => {
                                        this.removeAttribute('loading');

                                    })
                                    .catch(error => {
                                        console.error(error);
                                        this.removeAttribute('loading');
                                    })
                            }
                        })
                    }
                }
            }
        });
    }
});
